import styles from '@components/components/Newsletter/Newsletter.module.scss';
import { Card, CardBody } from '@wienenergiegithub/ui-next/';
import React from 'react';
import classNames from 'classnames';

const FormDecider = ({ area, form, isOverlay }) => {
  if (area === 'privat' && form === 'subscribe') {
    return (
      <Card
        className={classNames(styles.card, {
          [styles.overlay]: isOverlay,
        })}
        data-testid="newsletter-formdecider-privat-subscribe"
        id="newsletter"
      >
        <CardBody>
          <div data-form-block-id="5d5e2667-ca15-ee11-8f6d-000d3ab8ac55" />
          <div id="dt35q2y9Zp84RCsHzArJ1O5yvpW-j7YCQaTzRDiL08is" />
          <div
            className="d365-mkt-config"
            data-hostname="5542cb3ca5694bd999a99e458d7e0887.svc.dynamics.com"
            data-website-id="t35q2y9Zp84RCsHzArJ1O5yvpW-j7YCQaTzRDiL08is"
            style={{ display: 'none' }}
          />
        </CardBody>
      </Card>
    );
  }

  if (area === 'privat' && form === 'unsubscribe') {
    return (
      <>
        <div
          data-form-block-id="d959e731-872c-ee11-bdf4-0022489ba2a0"
          data-testid="newsletter-formdecider-privat-unsubscribe"
        />
        <div id="dIIDprAeBPRz_yyWPH-xh2lVdK1uqWNrWoH2mKSNeGmY" />
        <div
          className="d365-mkt-config"
          data-hostname="5542cb3ca5694bd999a99e458d7e0887.svc.dynamics.com"
          data-website-id="IIDprAeBPRz_yyWPH-xh2lVdK1uqWNrWoH2mKSNeGmY"
          style={{ display: 'none' }}
        />
      </>
    );
  }

  if (area === 'privat' && form === 'update') {
    return (
      <>
        <div
          data-form-block-id="711b0f1f-1b6c-ee11-9ae7-000d3ab085d7"
          data-testid="newsletter-formdecider-privat-update"
        />
        <div id="d4PUE26DQxXL-hSatljjYOM9-8looPdD8iX_6LzDc8wY" />
        <div
          className="d365-mkt-config"
          data-hostname="5542cb3ca5694bd999a99e458d7e0887.svc.dynamics.com"
          data-website-id="4PUE26DQxXL-hSatljjYOM9-8looPdD8iX_6LzDc8wY"
          style={{ display: 'none' }}
        />
      </>
    );
  }

  if (area === 'privat' && form === 'raus_aus_gas') {
    return (
      <Card
        className={classNames(styles.card, {
          [styles.overlay]: isOverlay,
        })}
        data-testid="newsletter-formdecider-privat-raus_aus_gas"
        id="newsletter"
      >
        <CardBody>
          <div data-form-block-id="3e251274-24da-ee11-904b-000d3ab9e248" />
          <div id="d3cwZhvCzGUUI7QbNygGvxyaX73cOoO5Ea3YPNTvPWDE" />
          <div
            className="d365-mkt-config"
            data-hostname="5542cb3ca5694bd999a99e458d7e0887.svc.dynamics.com"
            data-website-id="3cwZhvCzGUUI7QbNygGvxyaX73cOoO5Ea3YPNTvPWDE"
            style={{ display: 'none' }}
          />
        </CardBody>
      </Card>
    );
  }

  if (area === 'business' && form === 'subscribe') {
    return (
      <Card
        className={classNames(styles.card, {
          [styles.overlay]: isOverlay,
        })}
        data-testid="newsletter-formdecider-business-subscribe"
        id="newsletter"
      >
        <CardBody>
          <div data-form-block-id="52717d18-3f46-ee11-be6e-000d3ade2abb" />
          <div id="dU_PIJ0EFmyNDMVKRSUU7ft9WHB0N92gAW1nX6YKAbcQ" />
          <div
            className="d365-mkt-config"
            data-hostname="5542cb3ca5694bd999a99e458d7e0887.svc.dynamics.com"
            data-website-id="U_PIJ0EFmyNDMVKRSUU7ft9WHB0N92gAW1nX6YKAbcQ"
            style={{ display: 'none' }}
          />
        </CardBody>
      </Card>
    );
  }

  if (area === 'business' && form === 'unsubscribe') {
    return (
      <>
        <div
          data-form-block-id="bd895e86-f847-ee11-be6d-0022489b42dc"
          data-testid="newsletter-formdecider-business-unsubscribe"
        />
        <div id="dNk2zJ8y6FF6wsVSPng3qerqq_RgmnmcqdUu3PAESLT4" />
        <div
          className="d365-mkt-config"
          data-hostname="5542cb3ca5694bd999a99e458d7e0887.svc.dynamics.com"
          data-website-id="Nk2zJ8y6FF6wsVSPng3qerqq_RgmnmcqdUu3PAESLT4"
          style={{ display: 'none' }}
        />
      </>
    );
  }

  if (form === 'akv_unsubscribe') {
    return (
      <>
        <div
          data-form-block-id="042bee29-5756-ef11-bfe3-002248a2c66b"
          data-testid="newsletter-formdecider-akv_unsubscribe"
        />
        <div id="dmnhuNJysSAnsUn50dLoinZYNVdwFBshLStPOW9wsIBc" />
        <div
          className="d365-mkt-config"
          data-hostname="5542cb3ca5694bd999a99e458d7e0887.svc.dynamics.com"
          data-website-id="mnhuNJysSAnsUn50dLoinZYNVdwFBshLStPOW9wsIBc"
          style={{ display: 'none' }}
        />
      </>
    );
  }

  if (area === 'privat' && form === 'msd_subscribe') {
    return (
      <Card
        className={classNames(styles.card, {
          [styles.overlay]: isOverlay,
        })}
        data-testid="newsletter-formdecider-privat-msd_subscribe"
        id="newsletter-msd-subscribe"
      >
        <CardBody>
          <div
            data-cached-form-url="https://assets-eur.mkt.dynamics.com/7e7263cb-f926-4414-86e4-8434782151bd/digitalassets/forms/0ae7f8e9-e95e-ef11-bfe3-002248a1c070 "
            data-form-api-url="https://public-eur.mkt.dynamics.com/api/v1.0/orgs/7e7263cb-f926-4414-86e4-8434782151bd/landingpageforms"
            data-form-id="0ae7f8e9-e95e-ef11-bfe3-002248a1c070"
          />
        </CardBody>
      </Card>
    );
  }

  // Test scripts are only to be used on testing sites or password protected prod sites
  if (form === 'test_subscribe') {
    return (
      <>
        <div
          data-form-block-id="b964bdde-fffe-ed11-8f6e-000d3adf76d2"
          data-testid="newsletter-formdecider-test_subscribe"
        />
        <div id="dIAjZGrsaQpMbq9wb7V84DjtpfUptCE8vOkKKi90RsYM" />
        <div
          className="d365-mkt-config"
          data-hostname="8f67e5bad37d46f790f815719f080879.svc.dynamics.com"
          data-website-id="IAjZGrsaQpMbq9wb7V84DjtpfUptCE8vOkKKi90RsYM"
          style={{ display: 'none' }}
        />
      </>
    );
  }

  if (form === 'test_unsubscribe') {
    return (
      <>
        <div
          data-form-block-id="c3d902d2-2905-ee11-8f6e-000d3ab23bc8"
          data-testid="newsletter-formdecider-test_unsubscribe"
        />
        <div id="dgmMgqv-wrGnauQKQcKmTr7p-GygT3yN8Lai02jJ8DKI" />
        <div
          className="d365-mkt-config"
          data-hostname="8f67e5bad37d46f790f815719f080879.svc.dynamics.com"
          data-website-id="gmMgqv-wrGnauQKQcKmTr7p-GygT3yN8Lai02jJ8DKI"
          style={{ display: 'none' }}
        />
      </>
    );
  }

  return null;
};
export default FormDecider;
